function ServiceArea() {
	return (
		<section className='bg-[#FFEAC8]'>
			<div className='max-w-[1440px] w-[90%] mx-auto flex justify-between lg:items-start items-center gap-x-18 gap-10 lg:flex-row flex-col py-10'>
				<h2
					className='md:text-[64px]/[76.8px] text-3xl/[58px] font-semibold text-[#034021]'>
					Service Coverage Areas
				</h2>
				<div className='text-[#11112D] md:text-2xl/[50px] text-xl/10 font-light'>
					<p>We proudly serve individuals in:</p>
					<ul>
						<li>
							<span className='font-medium'>Maryland:</span>
							Baltimore, Montgomery County, Prince George’s County, and
							surrounding areas.
						</li>
						<li>
							<span className='font-medium'>Virginia:</span>
							Alexandria, Arlington, Fairfax, and Richmond.
						</li>
						<li>
							<span className='font-medium'>Washington, DC:</span>
							The entire metropolitan area, focusing on under-served
							neighborhoods.
						</li>
					</ul>
				</div>
			</div>
		</section>
	);
}
export default ServiceArea;

//
//
//
